import React from 'react';
import { DataSourceProps } from '../types';
import { useDataSource } from '../hook/useDataSource';

export const withDataSource = <P extends object>(
  Component: React.ComponentType<P & DataSourceProps>,
): React.FC<Omit<P, keyof DataSourceProps>> => (props: Omit<P, keyof DataSourceProps>) => {
    const dataSourceProps = useDataSource();

    return <Component {...(props as P)} {...dataSourceProps} />;
  };
